import { VideoCard } from '@/components/partial/video-card';
import { Carousel } from '@/components/shared/carousel';
import { useResourcesIndex } from '@/data/resource-catalog';
import { CardsSkeleton } from '@/packages/home/components/skeleton';

export const CareerVideosSection = () => {
  const videoIds: number[] = [
    121, 115, 125, 124, 127, 126, 123, 92, 93, 106, 99, 100, 102, 103, 108, 109,
    138, 110, 139, 112, 114, 117, 118, 130, 132, 137, 128, 136, 129, 133, 135,
    98, 131, 119, 120, 95, 134, 101, 122, 104, 96, 111, 105, 113, 107, 94, 116,
    97,
  ];
  const { data, error, isFetching } = useResourcesIndex({ videoIds });
  const videos = data?.resource?.youtube_video ?? [];

  if (isFetching) return <CardsSkeleton withTextSkeleton={false} />;

  if (error || !videos?.length) return null;

  const slidesComponents = videos?.map((video) => {
    return <VideoCard video={video} key={video.uuid} />;
  });

  return <Carousel slidesComponents={slidesComponents} />;
};
